<template>
    <section class="content">
      <!-- <keep-alive> -->
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br/>
        <h4>Loading...</h4>
      </div>
      <div>
        <div class="box box-info">
          <!-- <form> -->
            <!-- <div class="p-fluid p-formgrid p-grid">
        
              <div class="p-field p-col-12 p-md-2">
                <label for="fromDate">From Date</label>
                <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">To Date</label>
                <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
                <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">Store</label>
                <Dropdown
                  v-if="!setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select store"
                  :showClear="true"
                />
                <Dropdown
                  v-if="setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select store"
                  :disabled="true"
                />
              </div>
  
            </div> -->
          <!-- </div> -->
          <!-- </form> -->
          <!-- <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()"
             v-if="this.dublicateSalesChildHeaderLists.length > 0">
            <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a> -->

          <!-- <div class="p-field p-col-12 p-md-6">
            <label for="name">Toatl Cash Sales R.s: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.cashSales }}</label>
  
            <label style="margin-left: 12%;" for="name">Toatl Esewa Sales R.s: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.esewaSales }}</label>
          </div> -->
  

     
  
        
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-col-12"> -->
              <DataTable :value="dublicateSalesChildHeaderLists"
                         :paginator="true" ref="po" 
                         :rows="100" :filters="filters"
                         :rowsPerPageOptions="[100,500,1000]"
                         class="p-datatable-responsive p-datatable-gridlines"
                         data-key="id">
                         <template #header>
        <div style="text-align: left">
            <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
        </div>
    </template>
                <Column header="S.N">
                  <template #body="sl">
                    {{ sl.index + 1 }}
                  </template>
                </Column>
                <Column header="Miti" :sortable="true" field="salesDateNepali" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['salesDateNepali']"/>
                  </template>
                </Column>
                <Column header="Date" :sortable="true" field="salesDate" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['salesDate']"/>
                  </template>
                </Column>
  
                 <Column header="Time" :sortable="true" field="time" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['time']"/>
                  </template>
                </Column>
  
                <Column header="Bill No" :sortable="true" field="billPrefix" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['billPrefix']"/>
                  </template>
                </Column>
                <Column header="Customer" :sortable="true" field="customerName" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['customerName']"/>
                  </template>
                  <template #footer>
                    Total:
                  </template>
                </Column>
                <Column header="Contact" :sortable="true" field="contactNumber" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']"/>
                  </template>
                </Column>
                <Column header="Address" :sortable="true" field="deliveryAddress" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['deliveryAddress']"/>
                  </template>
                </Column>
                <Column header="Pay Status" bodyStyle="text-align: right" field="paymentStatus"
                        :sortable="true" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['paymentStatus']"/>
                  </template>
                  <!-- <template #editor="slotProps">
                    <Dropdown v-model="slotProps.data['paymentStatus']" :options="statusesPay"
                              @change="updatePaymentStatus(slotProps.data)"
                              optionLabel="label" optionValue="value" placeholder="Select a Status">
                      <template #option="slotProps">
                        <span>{{ slotProps.option.label }}</span>
                      </template>
                    </Dropdown>
                  </template>
                  <template #body="slotProps">
                    {{ getPayStatusLabel(slotProps.data.paymentStatus) }}
                  </template> -->
                </Column>
                <Column header="Pay Method" :sortable="true" field="paymentMethod" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['paymentMethod']"/>
                  </template>
                </Column>
                <Column header="Dis Amt" bodyStyle="text-align: right" field="discountAmount" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['discountAmount']"/>
                  </template>
                  <template #footer>
                    {{ totalDiscountAmount.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Amount" bodyStyle="text-align: right" field="billAmount" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['billAmount']"/>
                  </template>
                  <template #footer>
                    {{ totalBillAmount.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Counter" bodyStyle="text-align: right" field="counterName" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['counterName']"/>
                  </template>
                </Column>
                <Column header="Store" bodyStyle="text-align: right" field="warehouseName" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['warehouseName']"/>
                  </template>
                </Column>
                <Column header="Entered By" bodyStyle="text-align: right" field="enteredBy" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['enteredBy']"/>
                  </template>
                </Column>
  
                <Column header="Updated By" bodyStyle="text-align: right" field="updatedBy" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                  </template>
                </Column>
                <Column header="Action" headerStyle="width:14em">
                  <template #body="slotProps">
  
                    <Button icon="pi pi-eye" class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                            @click="viewPOSSalesDetail(slotProps.data)"/>
                    <Button icon="pi pi-print" class="p-button-raised p-button-secondary" v-tooltip.top="'Print'"
                            @click="printPage(slotProps.data)"/>
                    <!-- <Button icon="fa fa-truck" v-if="slotProps.data.deliveryAddress !== ''" v-tooltip.top="'Delivery'"
                            class="p-button-raised"
                            @click="printDeliveryPage(slotProps.data)"/>
                    <Button icon="pi pi-refresh" v-if="slotProps.data.deliveryAddress !== ''" v-tooltip.top="'Exchange'"
                            class="p-button-raised p-button-secondary"
                            @click="printExchangePage(slotProps.data)"/> -->
                  </template>
                </Column>
                <template slot="body.append">
                  <tr class="pink--text">
                    <th class="title">Totals</th>
                  </tr>
                </template>
                <template #empty>No record found</template>
              </DataTable>
            <!-- </div>
          </div> -->
        </div>
    </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
    </section>
  </template>
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dialog from '../../layout/dialog'
  import globalKey from '../../../store/globalKey'
  import axios from 'axios'
  import $ from 'jquery'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  import InputMask from 'primevue/inputmask'
  import Dropdown from 'primevue/dropdown'
  
  export default {
    name: 'posSalesReport',
    data() {
      return {
        fromDate: null,
        toDate: null,
        loading: false,
        dialogShow: false,
        setWarehouseData: false,
        columnList: '',
        filters: {},
        englishDateEnabled: true,
        enableEdit: false,
        enableDelete: false,
        statusesPay: [{label: 'Paid', value: 'Paid'}, {label: 'Unpaid', value: 'Unpaid'}],
        posSalesId: null,
        cashSales: 0,
        esewaSales: 0,
        khaltiSales: 0,
        darazSales: 0,
        bankSales: 0,
        fonepaySales: 0,
        warehouseId: '',
        totalDiscountAmount: 0,
        totalBillAmount: 0
      }
    },
    computed: {
      salesDublicateChildHeaderLists() {
        return this.$store.state.pos.dublicateSalesChildHeaderLists
      },
      warehouseLists() {
        return this.$store.state.warehouse.warehouseDropDownList
      }
    },
    mounted() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
      this.checkEnableDelete()
      this.warehouseList()
      this.setWarehouse()
      this.columnNames()
      this.salesDublicateChildHeaderList()
    },
    methods: {
      setWarehouse() {
        if (this.$store.state.warehouseData.id > 0) {
          this.setWarehouseData = true
          this.warehouseId = this.$store.state.warehouseData
        } else if (this.warehouseLists.length === 1) {
          this.warehouseId = this.warehouseLists[0]
        }
      },
      async warehouseList() {
        await this.$store.dispatch('loadWarehouseDropDown')
      },
      async salesDublicateChildHeaderList() {
        await this.$store.dispatch('loadSalesChildDublicateHeaderLists')
      },
      async viewPOSSalesDetail(data) {
        let SalesDetail = {
          returningAmount: data.returningAmount,
          contactNumber: data.contactNumber,
          billPrefix: data.billPrefix,
          billNo: data.billNo,
          paymentMethod: data.paymentMethod,
          salesDateNepali: data.salesDateNepali,
          subTotalAmount: data.subTotal,
          nonTaxableAmount: data.nonTaxableAmount,
          taxableAmount: data.taxableAmount,
          vatAmount: data.vatAmount,
          billAmount: data.billAmount,
          vatTypeEnum: data.vatTypeEnum,
          tenderAmount: data.tenderAmount,
          discountAmt: data.discountAmount,
          deliveryAddress: data.deliveryAddress,
          deliveryAmount: data.deliveryAmount,
          remarks: data.remarks,
          childSalesDetailsDTOList: data.childSalesDetailsDTOList
        }
        this.$router.push({name: 'Unsettled Details', params: {UnsettledData: SalesDetail}})
      },
      exportCSV() {
        this.$refs.dt.exportCSV()
      },
      exportCSV1() {
        let data = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          columnList: this.columnList
        }
        axios({
          url: globalKey + '/fileDownload/excelPosReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/settled' + '/' + this.$store.getters.fyId + '/' + data.columnList,
          method: 'get',
          headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
          const link = document.createElement('a')
          const contentDisposition = response.headers['content-disposition']
          let fileName = 'posSalesReport.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1]
            }
          }
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
      },
      checkEnableDelete() {
        if (this.$store.getters.modules.includes(',5.13')) {
          this.enableDelete = true
        }
      },
      columnNames() {
        for (let i = 1; i < this.$refs.po.columns.length; i++) {
          this.columnList += this.$refs.po.columns[i].header + ','
        }
      },
      printPage(data) {
        data.printTyp = 'bill'
        this.$router.push({name: 'posPrintPage', params: {printData: data}})
      },
      async updatePaymentStatus(data) {
        let payment = {
          id: data.id,
          status: data.paymentStatus
        }
        let response = await this.$store.dispatch('paymentStatusUpdate', payment)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: '',
            detail: 'Payment Status' + response.data.message,
            life: 10000
          })
        }
        // // debugger
      },
      getPayStatusLabel(payStatus) {
        switch (payStatus) {
          case 'Paid':
            return 'Paid'
  
          case 'Unpaid':
            return 'Unpaid'
  
          default:
            return 'NA'
        }
      },
      async deleteReport(value) {
        if (value.trim() === '') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
          this.dialogShow = true
          return
        }
        let deleteRe = {
          inventoryOutHeaderId: this.posSalesId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteSalesInvoice', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        }
        this.dialogShow = false
      },
      setEnglishDate() {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      reset() {
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.setNepaliDate()
        } else {
          this.setEnglishDate()
        }
        window.location.reload()
      },
      printDeliveryPage(data) {
        this.$router.push({name: 'posDeliveryPrint', params: {printData: data}})
      },
      printExchangePage(data) {
        data.billAmount = 0
        this.$router.push({name: 'posDeliveryPrint', params: {printData: data}})
      },
      cancel(data) {
        this.dialogShow = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.posSalesId = id
      },
      setNepaliDate() {
        if (this.$store.getters.nepaliNewDate !== '') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        }
      },
      nepaliDate() {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      Dialog,
      InputText,
      Button,
      InputMask,
      Dropdown
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css">
  </style>



// WEBPACK FOOTER //
// dublicatePosSalesEntry.vue?34f0dec5